
define('text!templates/modules/template/assignment/assignment-content.html',[],function () { return '<div class="panel-body">\n    <ul class="menu-actions nav nav-pills"></ul>\n    <div class="template-list"></div>\n</div>\n';});

